import { HttpError } from '@gyym/sdk'
import React from 'react'

import { useGyymClient } from './useGyymClient'

export const useGyymApiGlobalErrorHandler = (
  handler: (err: HttpError) => void | Promise<void>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deps: any[] = [],
) => {
  const client = useGyymClient()

  const errorHandler = React.useCallback(handler, [handler, ...deps])
  React.useEffect(() => {
    const unregister = client.registerErrorHandler(errorHandler)
    return unregister
  }, [client, errorHandler])
}
